import axios from "axios"
export const login = (data) => async(dispatch) => {
    try {
        dispatch({type:"LOGIN_PENDING"})
        const response = await axios.post("/api/supplier/supplier-login",data)
        localStorage.setItem("cmyuva-supplier",JSON.stringify(response.data?.data))
        dispatch({type:"LOGIN_FULFILLED",payload:response.data.data})
        
    } catch (error) {
        dispatch({type:"LOGIN_FAILED",payload:error.response.data})
    }
} 

export const logout = () => async(dispatch) =>{
   localStorage.removeItem("cmyuva-supplier")
   dispatch({type:"LOG_OUT_FULFILLED"})
}

export const sendOtp = (mobile) => async (dispatch) => {
    try {
      dispatch({ type: "SEND_OTP" });
  
      const response = await axios.post("/api/cm-yuva/sms-otp", {
        mobile,
      });
      dispatch({
        type: "SEND_OTP_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "SEND_OTP_REJECTED",
        payload: error.response,
      });
    }
  };
  
  export const resendOtp = (mobile) => async (dispatch) => {
    try {
      dispatch({ type: "RESEND_OTP" });
  
      const response = await axios.post("/api/cm-yuva/sms-otp", {
        mobile,
      });
      dispatch({
        type: "RESEND_OTP_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "RESEND_OTP_REJECTED",
        payload: error.response,
      });
    }
  };
  
  export const verifyOtp = (mobile, otp) => async (dispatch) => {
    try {
      dispatch({ type: "VERIFY_OTP" });
  
      const response = await axios.post("/api/cm-yuva/verify-sms-otp", { mobile, otp });
      dispatch({
        type: "VERIFY_OTP_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "VERIFY_OTP_REJECTED",
        payload: error.response,
      });
    }
  };
  export const changePassword = (mobile, password) => async (dispatch) => {
    try {
      dispatch({ type: "CHANGE_PASSWORD" });
  
      const response = await axios.post("/api/supplier/change-password", { mobile, password ,password_confirmation:password});
      dispatch({
        type: "CHANGE_PASSWORD_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "CHANGE_PASSWORD_REJECTED",
        payload: error.response,
      });
    }
  };

  export const submitEnquiry = (data) => async (dispatch) => {
    try {
      dispatch({ type: "SUBMIT_ENQUIRY_PENDING" });
  
      const response = await axios.post("/api/supplier/submit-enquiry", {...data});
      dispatch({
        type: "SUBMIT_ENQUIRY_FULFILLED",
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: "SUBMIT_ENQUIRY_REJECTED",
        payload: error.response,
      });
    }
  };

